import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import PageHeader from 'commons/src/components/headers/PageHeader';
import SubHeader from 'commons/src/components/headers/SubHeader';
import { RequiredRoleLevel } from 'commons/src/models/commonEnums';
import { ActionButton } from 'commons/src/models/menuModels';
import { paths } from '../../../constants';
import McpClientForm from './McpClientForm';

const AddMcpClient = (): React.ReactElement => {
    const navigate = useNavigate();
    const { t: txt } = useTranslation();

    const close = (): void => navigate(`/${paths.integrationsMcp}`);

    const actionButtons: ActionButton[] = [
        {
            onClick: close,
            testAttr: 'close-add-mcp-client',
            id: 'CloseAddMcpClient',
            title: 'Close',
            color: 'secondary',
            requiredGroupTypes: [],
            requiredRoleLevel: RequiredRoleLevel.ANY_ROLE,
        },
    ];

    return (
        <>
            <PageHeader title={txt('McpIntegration.ClientFormTitle')} />
            <div className="page-wrapper__medium">
                <SubHeader actionButtons={actionButtons} />
            </div>
            <McpClientForm />
        </>
    );
};

export default AddMcpClient;
